import { useSyncExternalStore } from "react";

/**
 * spec11 FR10: "Review" in the conflict toast opens the review on the notes page, which may
 * not be mounted yet; the request waits here until it is.
 */
let requested = false;
const listeners = new Set<() => void>();

export function requestConflictReview() {
  requested = true;
  for (const listener of listeners) listener();
}

/** True once per request; `done` clears it. */
export function useConflictReviewRequest(): { requested: boolean; done: () => void } {
  const value = useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => void listeners.delete(listener);
    },
    () => requested,
    () => false,
  );
  return {
    requested: value,
    done() {
      requested = false;
      for (const listener of listeners) listener();
    },
  };
}
